/**
 * Known Fair Pay location hierarchies (Figma / ER-11733). Operating-country API rows
 * only carry id/code/name/flag — merge via `mergeLocationCountryConfig` before passing
 * to LocationPicker.
 */
export const DEFAULT_COUNTRY_CONFIGS = [
  {
    code: "US",
    name: "United States",
    icon: "https://flagcdn.com/us.svg",
    hasRegions: true,
    hasSubRegions: true,
    regionLabel: "State",
    metroLabel: "Metro Area",
    localUnitLabel: "County",
    independentScopes: false,
  },
  {
    code: "CA",
    name: "Canada",
    icon: "https://flagcdn.com/ca.svg",
    hasRegions: true,
    hasSubRegions: true,
    regionLabel: "Province",
    metroLabel: "Census Metro Area",
    localUnitLabel: "Census Division",
    independentScopes: false,
  },
  {
    code: "DE",
    name: "Germany",
    icon: "https://flagcdn.com/de.svg",
    hasRegions: true,
    hasSubRegions: true,
    regionLabel: "State (Bundesland)",
    metroLabel: "Metro Area (Arbeitsmarktregion)",
    localUnitLabel: "County (Kreis)",
    independentScopes: false,
  },
  {
    code: "BG",
    name: "Bulgaria",
    icon: "https://flagcdn.com/bg.svg",
    hasRegions: true,
    hasSubRegions: true,
    regionLabel: "Province (Област)",
    metroLabel: "Metro Area (Агломерационен ареал)",
    localUnitLabel: "Municipality (Община)",
    independentScopes: false,
  },
  {
    code: "RO",
    name: "Romania",
    icon: "https://flagcdn.com/ro.svg",
    hasRegions: false,
    hasSubRegions: true,
    regionLabel: null,
    metroLabel: "Metro Area (Municipiu)",
    localUnitLabel: "County (Județ)",
    independentScopes: true,
  },
];

/**
 * @param {object|null|undefined} item — operating country or picker row
 * @param {{ resolveIcon?: (item: object) => string }} [options]
 * @returns {object|null}
 */
export function mergeLocationCountryConfig(item, options = {}) {
  if (!item?.code) return null;
  const code = String(item.code).trim().toUpperCase();
  const known = DEFAULT_COUNTRY_CONFIGS.find((c) => c.code === code);
  const icon =
    (typeof options.resolveIcon === "function" ? options.resolveIcon(item) : null) ||
    item.icon ||
    known?.icon ||
    "";

  if (known) {
    return {
      ...known,
      ...item,
      code,
      name: item.name || known.name,
      icon: icon || known.icon,
      hasRegions: item.hasRegions ?? known.hasRegions,
      hasSubRegions: item.hasSubRegions ?? known.hasSubRegions,
      regionLabel: item.regionLabel ?? known.regionLabel,
      metroLabel: item.metroLabel ?? known.metroLabel,
      localUnitLabel: item.localUnitLabel ?? known.localUnitLabel,
      independentScopes: item.independentScopes ?? known.independentScopes,
    };
  }

  return {
    ...item,
    code,
    icon,
    hasRegions: item.hasRegions ?? false,
    hasSubRegions: item.hasSubRegions ?? false,
    regionLabel: item.regionLabel ?? null,
    metroLabel: item.metroLabel ?? null,
    localUnitLabel: item.localUnitLabel ?? null,
    independentScopes: item.independentScopes ?? false,
  };
}
